import { useState, useEffect } from "react";

const useImageValidation = (imageSource: string | undefined) => {
  const [imageExists, setImageExists] = useState<boolean | null>(null);

  useEffect(() => {
    const validateLogo = async () => {
      try {
        await new Promise((resolve, reject) => {
          const img = new Image();
          img.src = imageSource as string;

          img.onload = () => {
            setImageExists(true);
            resolve(true);
          };

          img.onerror = () => {
            setImageExists(false);
            reject();
          };
        });
      } catch (error) {
        /* empty */
      }
    };

    if (imageSource) {
      validateLogo();
    }
  }, [imageSource]);

  return { imageExists };
};

export default useImageValidation;
